export const TraktLogo = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 168 168" className={className} fill="currentColor">
    <path d="M84 0C37.6 0 0 37.6 0 84s37.6 84 84 84 84-37.6 84-84S130.4 0 84 0zm0 152c-37.5 0-68-30.5-68-68S46.5 16 84 16s68 30.5 68 68-30.5 68-68 68z"/>
    <path d="M117.4 79.7L97.3 45.2l-26.1 45.2 26.1 45.2 20.1-34.5h-16l-4.1 7.1-13.3-23 13.3-23 4.1 7.1h16zM84.4 90.3l-4.1-7.1H64.2l-4.1 7.1 13.3 23H73l-4.1-7.1 4.1-7.1h7.3l4.1 7.1-4.1 7.1h11.5l-8.4-14.5z"/>
  </svg>
);
